<template>

    <el-popover @hide="loadform=false" :ref="'popover_' + props.rowIndex" placement="top" width="400">

      <zxgform v-if="loadform" :formname="formname" :rowdata="rowdata" :formmodel="formmodel" @formdone="formdone"></zxgform>

      <el-button slot="reference" type="text" style="font-size: 1.1rem; font-weight: bold"
      @click="loadform=true"
        :disabled="theformeval(props.rowField.disabled)" size="mini">
        {{
          props.rowField.label||thetext
        }}</el-button>

    </el-popover>

</template>

<script>
import zxgform from "zxg-form"
export default {
  components: { zxgform },
  props: ["props", "rowdata", "formname", "formmodel", "thetext"],
  data() {
    return {
      loadform:false
    }
  },
  mounted(){
  },
  methods: {
    formdone(finaldata) {
      this.$refs["popover_" + this.props.rowIndex].doClose();
      if (this.formmodel == "inlineform" || this.props.rowField.result.includes("modify")) //|| !this.props.rowField.result.includes("modify")
      {
        console.log("modify original")
        Object.assign(this.rowdata, finaldata)
      }

      this.loadform=false
    },

    theformeval(val) {
      let name = localStorage.getItem('USER')
      let self = this;
      let props = this.props;
      let rowdata=this.rowdata
      return eval(val);
    },
  }

}
</script>


// WEBPACK FOOTER //
// src/components/utility/commonfields/form/gform.vue